import React from "react";
import { Fade } from "react-reveal";

import "./CertificationCard.css";

export default function CertificationCard(props) {
  const certificate = props.certificate;
  const theme = props.theme;
  return (
    <Fade bottom duration={2000} distance="20px">
      <div className="cert-card">
        <div className="content">
          <a href={certificate.link} target="_blank" rel="noopener noreferrer">
            <div className="content-overlay"></div>
            <div
              className="cert-header"
              style={{ backgroundColor: certificate.color_code }}
            >
              <img
                className="logo_img"
                src={require(`../../assets/images/${certificate.logo_path}`)}
                alt={certificate.alt_name}
              />
            </div>
            <div className="content-details fadeIn-top">
              <span
                className="iconify"
                data-icon="akar-icons:info"
                style={{
                  color: " #fff",
                  fontSize: "2rem",
                }}
              ></span>
            </div>
          </a>
        </div>
        <div className="cert-body">
          <h2 className="cert-body-title" style={{ color: theme.text }}>
            {certificate.title}
          </h2>
          <h3
            className="cert-body-subtitle"
            style={{ color: theme.secondaryText }}
          >
            {certificate.subtitle}
          </h3>
        </div>
      </div>
    </Fade>
  );
}
